export { ImgBox } from './ImgBox';
export type { Props } from './ImgBox.types';
